<template>
  <Modal
    v-if="!embedded"
    :value="value"
    :title="modalTitle"
    class-name="vc-add-resource-modal"
    width="560"
    :footer-hide="true"
    :mask-closable="false"
    @on-visible-change="onVisibleChange"
    @input="$emit('input', $event)"
  >
    <div class="vc-add-resource-body">
      <div class="vc-add-resource-field">
        <span class="vc-form-label">类型</span>
        <div class="vc-add-resource-type vc-add-resource-type--asr">
          <Icon type="ios-mic" size="18" class="vc-add-resource-type__icon" />
          <span>语音识别</span>
        </div>
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">名称</span>
        <Input v-model="form.name" placeholder="给资源取个名字" :maxlength="60" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">供应商</span>
        <Select v-model="form.provider" transfer placeholder="请选择">
          <Option v-for="item in providers" :key="item" :value="item">{{ item }}</Option>
        </Select>
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">app_id</span>
        <Input v-model="form.app_id" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">secret</span>
        <Input v-model="form.secret" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">key</span>
        <Input v-model="form.key" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">描述</span>
        <Input
          v-model="form.description"
          type="textarea"
          :rows="3"
          placeholder="简单描述资源的功能，这将展示给用户"
        />
      </div>
    </div>
    <div class="vc-add-resource-footer">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" class="vc-add-resource-confirm" :loading="submitting" @click="handleConfirm">
        确认
      </Button>
    </div>
  </Modal>
  <div v-else class="vc-add-resource-embedded">
    <div class="vc-add-resource-body">
      <div class="vc-add-resource-field">
        <span class="vc-form-label">类型</span>
        <div class="vc-add-resource-type vc-add-resource-type--asr">
          <Icon type="ios-mic" size="18" class="vc-add-resource-type__icon" />
          <span>语音识别</span>
        </div>
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">名称</span>
        <Input v-model="form.name" placeholder="给资源取个名字" :maxlength="60" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">供应商</span>
        <Select v-model="form.provider" transfer placeholder="请选择">
          <Option v-for="item in providers" :key="item" :value="item">{{ item }}</Option>
        </Select>
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">app_id</span>
        <Input v-model="form.app_id" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">secret</span>
        <Input v-model="form.secret" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">key</span>
        <Input v-model="form.key" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">描述</span>
        <Input
          v-model="form.description"
          type="textarea"
          :rows="3"
          placeholder="简单描述资源的功能，这将展示给用户"
        />
      </div>
    </div>
    <div class="vc-add-resource-footer">
      <Button type="primary" class="vc-add-resource-confirm" :loading="submitting" @click="handleConfirm">
        确认
      </Button>
    </div>
  </div>
</template>

<script>
import { ASR_RESOURCE_PROVIDERS } from '../../utils/tripleAccessHelpers'

const createEmptyForm = () => ({
  name: '',
  provider: ASR_RESOURCE_PROVIDERS[0] || '腾讯',
  app_id: '',
  secret: '',
  key: '',
  description: '',
})

export default {
  name: 'AddAsrResourceModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      providers: ASR_RESOURCE_PROVIDERS,
      form: createEmptyForm(),
      submitting: false,
    }
  },
  computed: {
    isEditMode() {
      return !!(this.resource && this.resource.id)
    },
    modalTitle() {
      return this.isEditMode ? '编辑资源' : '添加资源'
    },
  },
  methods: {
    fillFormFromResource(resource) {
      if (!resource || typeof resource !== 'object') {
        this.form = createEmptyForm()
        return
      }
      this.form = {
        name: String(resource.name != null ? resource.name : ''),
        provider: String(resource.provider != null ? resource.provider : '').trim()
          || ASR_RESOURCE_PROVIDERS[0]
          || '腾讯',
        app_id: String(resource.app_id != null ? resource.app_id : ''),
        secret: String(resource.secret != null ? resource.secret : ''),
        key: String(resource.key != null ? resource.key : ''),
        description: String(resource.description != null ? resource.description : ''),
      }
    },
    onVisibleChange(visible) {
      if (visible) {
        this.fillFormFromResource(this.resource)
        this.submitting = false
      }
    },
    handleCancel() {
      this.$emit('input', false)
    },
    validateForm() {
      const name = String(this.form.name != null ? this.form.name : '').trim()
      const provider = String(this.form.provider != null ? this.form.provider : '').trim()
      const appId = String(this.form.app_id != null ? this.form.app_id : '').trim()
      const secret = String(this.form.secret != null ? this.form.secret : '').trim()
      const key = String(this.form.key != null ? this.form.key : '').trim()
      const description = String(this.form.description != null ? this.form.description : '').trim()
      if (!name) {
        this.$Message.warning('请填写资源名称')
        return null
      }
      if (!provider) {
        this.$Message.warning('请选择供应商')
        return null
      }
      if (!appId) {
        this.$Message.warning('请填写 app_id')
        return null
      }
      if (!secret) {
        this.$Message.warning('请填写 secret')
        return null
      }
      if (!key) {
        this.$Message.warning('请填写 key')
        return null
      }
      if (!description) {
        this.$Message.warning('请填写描述')
        return null
      }
      const payload = { name, provider, app_id: appId, secret, key, description }
      if (this.isEditMode) {
        payload.id = String(this.resource.id).trim()
      }
      return payload
    },
    handleConfirm() {
      const payload = this.validateForm()
      if (!payload) return
      this.submitting = true
      this.$emit('confirm', payload)
      this.submitting = false
      if (this.embedded && !this.isEditMode) {
        this.form = createEmptyForm()
      } else if (!this.embedded) {
        this.$emit('input', false)
      }
    },
  },
}
</script>

<style lang="scss">
.vc-add-resource-modal {
  .ivu-modal-header {
    background: linear-gradient(180deg, #eef5ff 0%, #fff 100%);
    border-bottom: none;
    padding: 18px 24px 12px;
  }

  .ivu-modal-body {
    padding: 8px 24px 20px;
  }
}
</style>

<style lang="scss" scoped>
@import './shared.scss';

.vc-add-resource-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vc-add-resource-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vc-add-resource-type {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #0066a1;
  border-radius: 4px;
  color: #0066a1;
  font-size: 14px;
  background: #f5faff;
  width: fit-content;

  &__icon {
    color: #0066a1;
  }

  &--asr {
    border-color: #f0883e;
    color: #f0883e;
    background: #fff7f0;

    .vc-add-resource-type__icon {
      color: #f0883e;
    }
  }
}

.vc-add-resource-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 4px;
}

.vc-add-resource-confirm {
  min-width: 88px;
}
</style>
